import { useBattles } from 'react-render-hooks';
import {
  useTranslate,
  EModalTypes,
  useZustandModalKitStore,
  zustandModalKitSelector,
} from 'react-gldn-kit';
import { BattleHookInfo } from 'react-memory-optimization/dist/lib/store/casino/entities/casinoTournaments/types';

import { useHookFabric } from 'hooks/useHookFabric';

import styles from './CasinoTournamentPlayers.module.css';

const CasinoTournamentPlayers = () => {
  const closeModal = useZustandModalKitStore(
    zustandModalKitSelector.closeAndOpenModalAction
  );

  const battles = useHookFabric<BattleHookInfo[]>({
    fn: useBattles,
    customProps: {
      isFinished: false,
      isProviderExperimental: true,
    },
  });

  const { name: title } = useTranslate('tournament.players.title', '');

  const onClose = () => {
    closeModal(EModalTypes.Unknown);
  };

  return (
    <div>
      <div className={styles.playerContent}>
        {battles?.[0].players?.map((player, inx) => (
          <div key={player.id} className={styles.wrapperPlayer}>
            {/* <TournamentPlayerRow position={inx + 1} {...player} /> */}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CasinoTournamentPlayers;
